/**
 * Scribbr Citation Generator
 *
 * Citation generator; resources scoped to academic publisher domains.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 43.22.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'epbobagokhieoonfplomdklollconnkl';
export const scribbr: ExtensionDefinition = {
  id: ID,
  name: "Scribbr Citation Generator",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  requiredOrigin: 'https://www.sciencedirect.com',
  notes: "Citation generator; resources scoped to academic publisher domains.",
  signals: [
    { id: 'war-index-css', kind: 'web-accessible-resource',
      description: 'Fetch index.css, exposed only to https://www.sciencedirect.com.',
      weight: 1, run: () => probeFetch(ID, 'index.css') },
    { id: 'war-gdocs-css', kind: 'web-accessible-resource',
      description: 'Fetch gdocs.css, exposed only to https://www.sciencedirect.com.',
      weight: 0.5, run: () => probeFetch(ID, 'gdocs.css') },
  ],
};
